import type { CSSProperties } from 'react';

export const PORTAL_ICON_SCALE = 1.10;
export const EMAIL_EVENT_ICON_BASE_SIZE = 20;

// Shared by Analytics, Email Events, expanded timelines, detail dialogs, and Home.
export const EMAIL_EVENT_ICON_STYLE: CSSProperties = {
  width: EMAIL_EVENT_ICON_BASE_SIZE,
  height: EMAIL_EVENT_ICON_BASE_SIZE,
  zoom: PORTAL_ICON_SCALE,
};

export const EMAIL_EVENT_ICON_STYLES = {
  standard: EMAIL_EVENT_ICON_STYLE,
  compact: { width: 16, height: 16, zoom: PORTAL_ICON_SCALE },
  legend: { width: 14, height: 14, zoom: PORTAL_ICON_SCALE },
} satisfies Record<string, CSSProperties>;

export type EmailEventIconSize = keyof typeof EMAIL_EVENT_ICON_STYLES;
